// Happy-hour windows are anchored to America/New_York on the backend, so we
// render absolute instants in that zone to stay consistent with the schedule.
const ZONE = "America/New_York";

/** Accepts an epoch-millis number or an ISO string and returns a Date (or null). */
export const toDate = (value) => {
  if (value == null) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

/** "6:00 PM" in the happy-hour zone. */
export const formatTime = (value) => {
  const d = toDate(value);
  if (!d) return "";
  return d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    timeZone: ZONE,
  });
};

/**
 * "today" / "tomorrow" / weekday name, in the happy-hour zone.
 * Takes the i18next `t` function so the relative labels stay translatable.
 */
export const dayLabel = (value, t) => {
  const d = toDate(value);
  if (!d) return "";
  const ymd = (date) =>
    date.toLocaleDateString("en-CA", { timeZone: ZONE });
  const today = ymd(new Date());
  const tomorrow = ymd(new Date(Date.now() + 86400000));
  const target = ymd(d);
  if (target === today) return t("happyHour.today");
  if (target === tomorrow) return t("happyHour.tomorrow");
  return d.toLocaleDateString("en-US", { weekday: "long", timeZone: ZONE });
};

/** Whole hours between start/end timestamps (used for the "2 hour window" copy). */
export const windowHours = (start, end) => {
  const s = toDate(start);
  const e = toDate(end);
  if (!s || !e) return 0;
  return Math.max(0, Math.round((e.getTime() - s.getTime()) / 3600000));
};
